import React, { useState, useEffect } from "react";

import axiosInstance from "../../../../services/AxiosInstance";
import AccountBalanceWalletOutlinedIcon from "@mui/icons-material/AccountBalanceWalletOutlined";
import AccountBalanceOutlinedIcon from "@mui/icons-material/AccountBalanceOutlined";
import CreditCardOffOutlinedIcon from "@mui/icons-material/CreditCardOffOutlined";
import PriceCheckOutlinedIcon from "@mui/icons-material/PriceCheckOutlined";
import CardTravelOutlinedIcon from "@mui/icons-material/CardTravelOutlined";
import AttachMoneyOutlinedIcon from "@mui/icons-material/AttachMoneyOutlined";
import GroupOutlinedIcon from "@mui/icons-material/GroupOutlined";
import AddCardOutlinedIcon from "@mui/icons-material/AddCardOutlined";
import MoneyOutlinedIcon from "@mui/icons-material/MoneyOutlined";
function DashboardCards() {
  const [groupcountdata, setGroupCountdata] = useState("");
  const [contributiondata, setContributionData] = useState("");
  console.log(groupcountdata)
  const [loanoutstandingdata, setLoanOutstandingData] = useState("");
  const [loadpaiddata, setLoanPaidData] = useState("");
  const [investeddata, setInvesteddata] = useState("");
  const [interestdata, setInterestData] = useState("");

  const getGroupCount = () => {
    axiosInstance
      .get(
        `/dashboard/getGroupCount/${
          JSON.parse(localStorage.getItem("userDetails")).userId
        }`
      )
      .then((res) => {
        console.log(res.data.data.groupCount);
        setGroupCountdata(res.data.data?.groupCount);
      });
  };

  const getTotalContributionCount = () => {
    axiosInstance
      .get(
        `/dashboard/getContributionCount/${
          JSON.parse(localStorage.getItem("userDetails")).userId
        }`
      )
      .then((res) => {
        console.log(res.data.data.groupData[0].group_balance);
        setContributionData(res.data.data?.groupData[0].group_balance);
      });
  };

  const getTotalLoanOutstnading = () => {
    axiosInstance
      .get(
        `/dashboard/getLoanOutstandingCount/${
          JSON.parse(localStorage.getItem("userDetails")).userId
        }`
      )
      .then((res) => {
        console.log(res.data.data.loanData[0].loan_outstanding);
        setLoanOutstandingData(res.data.data?.loanData[0].loan_outstanding);
      });
  };

  const getTotalLoanPaidByUser = () => {
    axiosInstance
      .get(
        `/dashboard/getLoanPaidCount/${
          JSON.parse(localStorage.getItem("userDetails")).userId
        }`
      )
      .then((res) => {
        console.log(res.data.data.loanPaidData[0].amount);
        setLoanPaidData(res.data.data.loanPaidData[0].amount);
      });
  };

  const getTotalInvested = () => {
    axiosInstance
      .get(
        `/dashboard/getTotalInvestedCount/${
          JSON.parse(localStorage.getItem("userDetails")).userId
        }`
      )
      .then((res) => {
        console.log(res.data.data.investData[0].amount_invested);
        /*  setLoanPaidData(res.data.data.loanPaidData[0].amount); */

        setInvesteddata(res.data.data?.investData[0].amount_invested);
      });
  };

  const getTotalInterest = () => {
    axiosInstance
      .get(
        `/dashboard/getReturnCount/${
          JSON.parse(localStorage.getItem("userDetails")).userId
        }`
      )
      .then((res) => {
        console.log(res.data.data.returnData[0].returns);

        setInterestData(res.data.data?.returnData[0].returns);
      });
  };

  useEffect(() => {
    getGroupCount();
    getTotalContributionCount();
    getTotalLoanOutstnading();
    getTotalLoanPaidByUser();
    getTotalInvested();
    getTotalInterest();
  }, []);

  console.log(
    groupcountdata,
    contributiondata,
    loanoutstandingdata,
    loadpaiddata
  );

  return (
    <div>
      <div className="row">
        <div className="col-xl-4 col-sm-6 m-t35">
          <div
            className="card card-coin"
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {/*      <div
              style={{
                display: "inline-flex",
                justifyContent: "center",
                alignItems: "center",
                background: "yellowgreen",
                width: "80px",
                height: "80px",
                textAlign: "center",
                borderRadius: "50px",
                position: "absolute",
                top: "-35px",
                boxShadow: "0 10px 16px rgb(0 0 0 / 20%)",
              }}
            >
              <div
                style={{
                  background: "yellowgreen",
                  borderRadius: "50px",
                  width: "60px",
                  height: "60px",
                  alignItems: "center",
                  display: "inline-flex",
                  justifyContent: "center",
                 
                  border: "3px solid white",
                }}
              >
                <CardTravelOutlinedIcon
                  style={{ color: "white", fontSize: "40px" }}
                />
              </div>
            </div> */}

            <div
              className="card-body text-center"
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "column",
                marginTop: "0px",
              }}
            >
              {/* <svg
                className="mb-3 currency-icon"
                width="80"
                height="80"
                viewBox="0 0 80 80"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle cx="40" cy="40" r="40" fill="white" />
         

         <path
                  d="M40 0C17.9083 0 0 17.9083 0 40C0 62.0917 17.9083 80 40 80C62.0917 80 80 62.0917 80 40C80 17.9083 62.0917 0 40 0ZM40 72.5C22.0783 72.5 7.5 57.92 7.5 40C7.5 22.08 22.0783 7.5 40 7.5C57.9217 7.5 72.5 22.0783 72.5 40C72.5 57.9217 57.92 72.5 40 72.5Z"
                  fill="#FFAB2D"
                />
                <path
                  d="M42.065 41.2983H36.8133V49.1H42.065C43.125 49.1 44.1083 48.67 44.7983 47.9483C45.52 47.2566 45.95 46.275 45.95 45.1833C45.9517 43.0483 44.2 41.2983 42.065 41.2983Z"
                  fill="#FFAB2D"
                />
                <path
                  d="M40 10.8333C23.9167 10.8333 10.8333 23.9166 10.8333 40C10.8333 56.0833 23.9167 69.1666 40 69.1666C56.0833 69.1666 69.1667 56.0816 69.1667 40C69.1667 23.9183 56.0817 10.8333 40 10.8333ZM45.935 53.5066H42.495V58.9133H38.8867V53.5066H36.905V58.9133H33.28V53.5066H26.9067V50.1133H30.4233V29.7799H26.9067V26.3866H33.28V21.0883H36.905V26.3866H38.8867V21.0883H42.495V26.3866H45.6283C47.3783 26.3866 48.9917 27.1083 50.1433 28.26C51.295 29.4116 52.0167 31.025 52.0167 32.775C52.0167 36.2 49.3133 38.995 45.935 39.1483C49.8967 39.1483 53.0917 42.3733 53.0917 46.335C53.0917 50.2816 49.8983 53.5066 45.935 53.5066Z"
                  fill="#FFAB2D"
                />
                <path
                  d="M44.385 36.5066C45.015 35.8766 45.3983 35.0316 45.3983 34.08C45.3983 32.1916 43.8633 30.655 41.9733 30.655H36.8133V37.52H41.9733C42.91 37.52 43.77 37.12 44.385 36.5066Z"
                  fill="#FFAB2D"
                /> 
              </svg> */}

              <h2 className="text-black mb-2 font-w600">{contributiondata === null ? 0 :contributiondata?.toLocaleString("fi-FI")}</h2>
              <p className="mb-0 fs-13">
                <span className="text-success mr-1">Total Contributions</span>
              </p>
            </div>
          </div>
        </div>

        <div className="col-xl-4 col-sm-6 m-t35">
          <div
            className="card card-coin"
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {/*       <div
              style={{
                display: "inline-flex",
                justifyContent: "center",
                alignItems: "center",
                background: "#eb8153",
                width: "80px",
                height: "80px",
                textAlign: "center",
                borderRadius: "50px",
                position: "absolute",
                top: "-35px",
                boxShadow: "0 10px 16px rgb(0 0 0 / 20%)",
              }}
            >
              <div
                style={{
                  background: "#eb8153",
                  borderRadius: "50px",
                  width: "60px",
                  height: "60px",
                  alignItems: "center",
                  display: "inline-flex",
                  justifyContent: "center",

                  border: "3px solid white",
                }}
              >
                <CreditCardOffOutlinedIcon
                  style={{ color: "white", fontSize: "40px" }}
                />
              </div>
            </div> */}
            <div
              className="card-body text-center"
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "column",
                marginTop: "0px",
              }}
            >
              {/*   <svg
                className="mb-3 currency-icon"
                width="80"
                height="80"
                viewBox="0 0 80 80"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle cx="40" cy="40" r="40" fill="white" />
                <path
                  d="M40.725 0.00669178C18.6241 -0.393325 0.406678 17.1907 0.00666126 39.275C-0.393355 61.3592 17.1907 79.5933 39.2749 79.9933C61.3592 80.3933 79.5933 62.8093 79.9933 40.7084C80.3933 18.6241 62.8092 0.390041 40.725 0.00669178ZM39.4083 72.493C21.4909 72.1597 7.17362 57.3257 7.50697 39.4083C7.82365 21.4909 22.6576 7.17365 40.575 7.49033C58.5091 7.82368 72.8096 22.6576 72.493 40.575C72.1763 58.4924 57.3257 72.8097 39.4083 72.493Z"
                  fill="#374C98"
                />
                <path
                  d="M40.5283 10.8305C24.4443 10.5471 11.1271 23.3976 10.8438 39.4816C10.5438 55.549 23.3943 68.8662 39.4783 69.1662C55.5623 69.4495 68.8795 56.599 69.1628 40.5317C69.4462 24.4477 56.6123 11.1305 40.5283 10.8305ZM52.5455 56.9324H26.0111L29.2612 38.9483L25.4944 39.7317V36.6649L29.8279 35.7482L32.6447 20.2809H43.2284L40.8283 33.4481L44.5285 32.6647V35.7315L40.2616 36.6149L37.7949 50.2154H54.5122L52.5455 56.9324Z"
                  fill="#374C98"
                />
              </svg> */}
              <h2 className="text-black mb-2 font-w600">
                {loanoutstandingdata?.length > 0 ? (
                  "No Dues"
                ) : (
                  <> {loanoutstandingdata === null ? 0 :loanoutstandingdata?.toLocaleString("fi-FI")}</>
                )}
              </h2>
              <p className="mb-0 fs-14">
                <span className="text-danger mr-1">
                  Total Loans Outstanding
                </span>
              </p>
            </div>
          </div>
        </div>
        <div className="col-xl-4 col-sm-6 m-t35">
          <div
            className="card card-coin"
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {/*       <div
              style={{
                display: "inline-flex",
                justifyContent: "center",
                alignItems: "center",
                background: "#009688",
                width: "80px",
                height: "80px",
                textAlign: "center",
                borderRadius: "50px",
                position: "absolute",
                top: "-35px",
                boxShadow: "0 10px 16px rgb(0 0 0 / 20%)",
              }}
            >
              <div
                style={{
                  background: "#009688",
                  borderRadius: "50px",
                  width: "60px",
                  height: "60px",
                  alignItems: "center",
                  display: "inline-flex",
                  justifyContent: "center",

                  border: "3px solid white",
                }}
              >
                <AccountBalanceWalletOutlinedIcon
                  style={{ color: "white", fontSize: "40px" }}
                />
              </div>
            </div> */}
            <div
              className="card-body text-center "
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "column",
                marginTop: "0px",
              }}
            >
              {/*  <svg
                className="mb-3 currency-icon"
                width="80"
                height="80"
                viewBox="0 0 80 80"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle cx="40" cy="40" r="40" fill="white" />
                <path
                  d="M40.725 0.00669178C18.6241 -0.393325 0.406708 17.1907 0.00669178 39.275C-0.393325 61.3592 17.1907 79.5933 39.275 79.9933C61.3592 80.3933 79.5933 62.8093 79.9933 40.7084C80.3933 18.6241 62.8093 0.390041 40.725 0.00669178ZM39.4083 72.493C21.4909 72.1597 7.17365 57.3257 7.507 39.4083C7.82368 21.4909 22.6576 7.17365 40.575 7.49033C58.5091 7.82368 72.8097 22.6576 72.493 40.575C72.1763 58.4924 57.3257 72.8097 39.4083 72.493Z"
                  fill="#FF782C"
                />
                <path
                  d="M40.525 10.8238C24.441 10.5405 11.1238 23.391 10.8405 39.475C10.7455 44.5352 11.9605 49.3204 14.1639 53.5139H23.3326V24.8027C23.3326 23.0476 25.7177 22.4893 26.4928 24.0643L40 51.4171L53.5072 24.066C54.2822 22.4893 56.6674 23.0476 56.6674 24.8027V53.5139H65.8077C67.8578 49.6171 69.0779 45.2169 69.1595 40.525C69.4429 24.441 56.609 11.1238 40.525 10.8238Z"
                  fill="#FF782C"
                />
                <path
                  d="M53.3339 55.1806V31.943L41.4934 55.919C40.9334 57.0574 39.065 57.0574 38.5049 55.919L26.6661 31.943V55.1806C26.6661 56.1007 25.9211 56.8474 24.9994 56.8474H16.2474C21.4326 64.1327 29.8629 68.9795 39.475 69.1595C49.4704 69.3362 58.3908 64.436 63.786 56.8474H55.0006C54.0789 56.8474 53.3339 56.1007 53.3339 55.1806Z"
                  fill="#FF782C"
                />
              </svg> */}
              <h2 className="text-black mb-2 font-w600">
                {" "}
                {loadpaiddata ? `${loadpaiddata === null ? 0 :loadpaiddata?.toLocaleString("fi-FI")}` : "No Active Loans"}{" "}
              </h2>
              <p className="mb-0 fs-14">
                <span className="text-success mr-1">Total Loans Repaid</span>
              </p>
            </div>
          </div>
        </div>

        <div className="col-xl-4 col-sm-6 m-t35">
          <div
            className="card card-coin"
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {/*      <div
              style={{
                display: "inline-flex",
                justifyContent: "center",
                alignItems: "center",
                background: "#e83e8c",
                width: "80px",
                height: "80px",
                textAlign: "center",
                borderRadius: "50px",
                position: "absolute",
                top: "-35px",
                boxShadow: "0 10px 16px rgb(0 0 0 / 20%)",
              }}
            >
              <div
                style={{
                  background: "#e83e8c",
                  borderRadius: "50px",
                  width: "60px",
                  height: "60px",
                  alignItems: "center",
                  display: "inline-flex",
                  justifyContent: "center",
                
                  border: "3px solid white",
                }}
              >
                <AccountBalanceOutlinedIcon
                  style={{ color: "white", fontSize: "40px" }}
                />
              </div>
            </div> */}

            <div
              className="card-body text-center"
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "column",
                marginTop: "0px",
              }}
            >
              {/* <svg
                className="mb-3 currency-icon"
                width="80"
                height="80"
                viewBox="0 0 80 80"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle cx="40" cy="40" r="40" fill="white" />
                <path
                  d="M40.725 0.00669178C18.6241 -0.393325 0.406708 17.1907 0.00669178 39.275C-0.393325 61.3592 17.1907 79.5933 39.275 79.9933C61.3592 80.3933 79.5933 62.8093 79.9933 40.7084C80.3933 18.6241 62.8093 0.390041 40.725 0.00669178ZM39.4083 72.493C21.4909 72.1597 7.17365 57.3257 7.507 39.4083C7.82368 21.4909 22.6576 7.17365 40.575 7.49033C58.5091 7.82368 72.8097 22.6576 72.493 40.575C72.1763 58.4924 57.3257 72.8097 39.4083 72.493Z"
                  fill="#FF782C"
                />
                <path
                  d="M40.525 10.8238C24.441 10.5405 11.1238 23.391 10.8405 39.475C10.7455 44.5352 11.9605 49.3204 14.1639 53.5139H23.3326V24.8027C23.3326 23.0476 25.7177 22.4893 26.4928 24.0643L40 51.4171L53.5072 24.066C54.2822 22.4893 56.6674 23.0476 56.6674 24.8027V53.5139H65.8077C67.8578 49.6171 69.0779 45.2169 69.1595 40.525C69.4429 24.441 56.609 11.1238 40.525 10.8238Z"
                  fill="#FF782C"
                />
                <path
                  d="M53.3339 55.1806V31.943L41.4934 55.919C40.9334 57.0574 39.065 57.0574 38.5049 55.919L26.6661 31.943V55.1806C26.6661 56.1007 25.9211 56.8474 24.9994 56.8474H16.2474C21.4326 64.1327 29.8629 68.9795 39.475 69.1595C49.4704 69.3362 58.3908 64.436 63.786 56.8474H55.0006C54.0789 56.8474 53.3339 56.1007 53.3339 55.1806Z"
                  fill="#FF782C"
                />
              </svg> */}
              <h2 className="text-black mb-2 font-w600">{investeddata === null ? 0 :investeddata?.toLocaleString("fi-FI")}</h2>
              <p className="mb-0 fs-14">
                <span className="text-success mr-1">
                  Total Investment Amount
                </span>
              </p>
            </div>
          </div>
        </div>

        <div className="col-xl-4 col-sm-6 m-t35">
          <div
            className="card card-coin"
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {/*            <div
              style={{
                display: "inline-flex",
                justifyContent: "center",
                alignItems: "center",
                background: "#007aff",
                width: "80px",
                height: "80px",
                textAlign: "center",
                borderRadius: "50px",
                position: "absolute",
                top: "-35px",
                boxShadow: "0 10px 16px rgb(0 0 0 / 20%)",
              }}
            >
              <div
                style={{
                  background: "#007aff",
                  borderRadius: "50px",
                  width: "60px",
                  height: "60px",
                  alignItems: "center",
                  display: "inline-flex",
                  justifyContent: "center",

                  border: "3px solid white",
                }}
              >
                <MoneyOutlinedIcon
                  style={{ color: "white", fontSize: "40px" }}
                />
              </div>
            </div> */}
            <div
              className="card-body text-center"
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "column",
                marginTop: "0px",
              }}
            >
              {/*   <svg
                className="mb-3 currency-icon"
                width="80"
                height="80"
                viewBox="0 0 80 80"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle cx="40" cy="40" r="40" fill="white" />
                <path
                  d="M40.725 0.00669178C18.6241 -0.393325 0.406708 17.1907 0.00669178 39.275C-0.393325 61.3592 17.1907 79.5933 39.275 79.9933C61.3592 80.3933 79.5933 62.8093 79.9933 40.7084C80.3933 18.6241 62.8093 0.390041 40.725 0.00669178ZM39.4083 72.493C21.4909 72.1597 7.17365 57.3257 7.507 39.4083C7.82368 21.4909 22.6576 7.17365 40.575 7.49033C58.5091 7.82368 72.8097 22.6576 72.493 40.575C72.1763 58.4924 57.3257 72.8097 39.4083 72.493Z"
                  fill="#FF782C"
                />
                <path
                  d="M40.525 10.8238C24.441 10.5405 11.1238 23.391 10.8405 39.475C10.7455 44.5352 11.9605 49.3204 14.1639 53.5139H23.3326V24.8027C23.3326 23.0476 25.7177 22.4893 26.4928 24.0643L40 51.4171L53.5072 24.066C54.2822 22.4893 56.6674 23.0476 56.6674 24.8027V53.5139H65.8077C67.8578 49.6171 69.0779 45.2169 69.1595 40.525C69.4429 24.441 56.609 11.1238 40.525 10.8238Z"
                  fill="#FF782C"
                />
                <path
                  d="M53.3339 55.1806V31.943L41.4934 55.919C40.9334 57.0574 39.065 57.0574 38.5049 55.919L26.6661 31.943V55.1806C26.6661 56.1007 25.9211 56.8474 24.9994 56.8474H16.2474C21.4326 64.1327 29.8629 68.9795 39.475 69.1595C49.4704 69.3362 58.3908 64.436 63.786 56.8474H55.0006C54.0789 56.8474 53.3339 56.1007 53.3339 55.1806Z"
                  fill="#FF782C"
                />
              </svg> */}
              <h2 className="text-black mb-2 font-w600">{interestdata === null ? 0 :interestdata?.toLocaleString("fi-FI")}</h2>
              <p className="mb-0 fs-14">
                <span className="text-success mr-1">
                  Interest Received on Amount
                </span>
              </p>
            </div>
          </div>
        </div>

        <div className="col-xl-4 col-sm-6 m-t35">
          <div
            className="card card-coin"
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {/*    <div
              style={{
                display: "inline-flex",
                justifyContent: "center",
                alignItems: "center",
                background: "#ffab2d",
                width: "80px",
                height: "80px",
                textAlign: "center",
                borderRadius: "50px",
                position: "absolute",
                top: "-35px",
                boxShadow: "0 10px 16px rgb(0 0 0 / 20%)",
              }}
            >
              <div
                style={{
                  background: "#ffab2d",
                  borderRadius: "50px",
                  width: "60px",
                  height: "60px",
                  alignItems: "center",
                  display: "inline-flex",
                  justifyContent: "center",

                  border: "3px solid white",
                }}
              >
                <GroupOutlinedIcon
                  style={{ color: "white", fontSize: "40px" }}
                />
              </div>
            </div> */}

            <div
              className="card-body text-center"
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "column",
                marginTop: "0px",
              }}
            >
              {/* <svg
                className="mb-3 currency-icon"
                width="80"
                height="80"
                viewBox="0 0 80 80"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle cx="40" cy="40" r="40" fill="white" />
                <path
                  d="M40.725 0.00669178C18.6241 -0.393325 0.406678 17.1907 0.00666126 39.275C-0.393355 61.3592 17.1907 79.5933 39.2749 79.9933C61.3592 80.3933 79.5933 62.8093 79.9933 40.7084C80.3933 18.6241 62.8092 0.390041 40.725 0.00669178ZM39.4083 72.493C21.4909 72.1597 7.17362 57.3257 7.50697 39.4083C7.82365 21.4909 22.6576 7.17365 40.575 7.49033C58.5091 7.82368 72.8096 22.6576 72.493 40.575C72.1763 58.4924 57.3257 72.8097 39.4083 72.493Z"
                  fill="#00ADA3"
                />
                <path
                  d="M40.5283 10.8305C24.4443 10.5471 11.1271 23.3976 10.8438 39.4816C10.5438 55.549 23.3943 68.8662 39.4783 69.1662C55.5623 69.4495 68.8795 56.599 69.1628 40.5317C69.4462 24.4477 56.6123 11.1305 40.5283 10.8305ZM40.0033 19.1441L49.272 35.6798L40.8133 30.973C40.3083 30.693 39.6966 30.693 39.1916 30.973L30.7329 35.6798L40.0033 19.1441ZM40.0033 60.8509L30.7329 44.3152L39.1916 49.022C39.4433 49.162 39.7233 49.232 40.0016 49.232C40.28 49.232 40.56 49.162 40.8117 49.022L49.2703 44.3152L40.0033 60.8509ZM40.0033 45.6569L29.8296 39.9967L40.0033 34.3364L50.1754 39.9967L40.0033 45.6569Z"
                  fill="#00ADA3"
                />
              </svg> */}
              <h2 className="text-black mb-2 font-w600">{groupcountdata?.length === 0 ? 0 :groupcountdata?.toLocaleString("fi-FI")}</h2>
              <p className="mb-0 fs-14">
                <span className="text-success mr-1">No. of Group Members</span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DashboardCards;
